import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";

export class SetViolVersionCommand extends BasicCommand<SetViolVersionCommand> {
    get primaryKey(): IPrimaryKey<SetViolVersionCommand> {
        return {
            arbetsorderId: this.arbetsorderId
        };
    }
    arbetsorderId: number;
    viol3: boolean;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Arbetsorder";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "SetViolVersionCommand";
    constructor(init: (instance: SetViolVersionCommand) => void) {
        super(SetViolVersionCommand.$type, SetViolVersionCommand.$groupKey, CommandType.Replace);
        init(this);
    }
}
